module.exports = __webpack_public_path__ + "img/wh1.1cfcdfa1.png";